module.exports = __webpack_public_path__ + "static/media/pinpoint-list-project.51061c6b.svg";